import { module } from 'modujs';
import LocomotiveScroll from 'locomotive-scroll';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.scroll = new LocomotiveScroll({
            modularInstance: this,
            autoStart: false,
            scrollCallback: ({ scroll, limit, velocity, direction, progress }) => this.onScroll({ scroll, limit, velocity, direction, progress }),
        });

        // Force scroll to top
        if (history.scrollRestoration) {
            history.scrollRestoration = 'manual';
            window.scrollTo(0, 0);
        }

        this.initScrollToElements();

        window.addEventListener('scroll-start', () => { this.start(); });
        window.addEventListener('scroll-stop', () => { this.stop(); });
        window.addEventListener('scroll-resize', () => { this.resize(); });
    }

    start() {
        this.scroll.start();
    }

    stop() {
        this.scroll.stop();
    }

    resize() {
        this.scroll.resize();
    }

    onScroll({ scroll, limit, velocity, direction, progress }) {
        this.call('onScroll', { velocity: velocity, direction: direction }, 'Header');
    }

    scrollTo(target, delay = 0) {
        setTimeout(() => {
            this.scroll?.scrollTo(target, {
                duration: 1,
                lerp: 0.1,
                lock: false,
                easing: (x) => x === 1 ? 1 : 1 - Math.pow(2, -10 * x)
            });
        }, delay);
    }

    initScrollToElements() {
        this.el.querySelectorAll('[data-scroll-to]').forEach((elt) => {
            elt.addEventListener('click', (e) => {
                e.preventDefault();
                let target = document.querySelector('[data-scroll-target="' + elt.getAttribute('data-scroll-to') + '"]');
                let delay = elt.getAttribute('data-scroll-to-delay') ? parseInt(elt.getAttribute('data-scroll-to-delay')) : 0;
                if (target) {
                    this.scrollTo(target, delay);
                }
            });
        });
    }

    scrollTop(force) {
        if (!this.scroll) return;
        if (force) {
            this.scroll.scrollTo('top', { immediate: true });
        } else {
            scrollTo('top');
        }
    }

    scrollVHS() {
        this.scroll?.scrollTo('top', {
            duration: 2.5,
            lerp: 0.7,
            lock: true,
            easing: (x) => x === 1 ? 1 : 1 - Math.pow(2, -10 * x)
        });
    }

    destroy() {
        this.scroll.destroy();
    }

    addElements(container) {
        this.scroll.addScrollElements(container);
    }

    firstScroll() {
        setTimeout(() => {
            if (Math.round(window.scrollY) < 100) {
                this.scrollTo(document.querySelector('[data-scroll-target="mission"]'), 0);
            }
        }, 5000);
    }
}
